import { Invoice } from './invoice';
import { ResolvedBreadcrumb } from './resolved-breadcrumb';

export class InvoiceLine implements ResolvedBreadcrumb
{
	id: number;
	invoice: Invoice;
	invoice_id: number;
	characteristic: string;
	description: string;
	amount: number;
	price_per_unit: number;
	price_unit: string;
	vat_type: string;
	vat_percentage: number;
	price_ex_vat: number;
	price_inc_vat: number;
	is_manual: boolean;
	position: number;

	getBreadcrumb()
	{
		return this.characteristic;
	}
}



// WEBPACK FOOTER //
// ./src/app/models/invoice-line.ts